export default __webpack_public_path__ + "static/media/intro_right_image.70f8ac7f.webp";